export type InsideItem = {
  lead: string
  rest: string
}

export const insideItems: InsideItem[] = [
  { lead: '10+ ready-to-print visual routines', rest: ' (morning, after school, bedtime and more)' },
  { lead: 'Editable daily checklist', rest: ' to build your own routine step by step' },
  { lead: 'Game-style routine boards', rest: ' (4 different versions)' },
  { lead: 'Visual time tracker', rest: ' with a game-mode clock' },
  { lead: 'Emotions & values bedtime stories', rest: ' to read together' },
  { lead: 'Healthy sleep routine', rest: ' — with zero bedtime battles' },
  { lead: 'Practical guides', rest: ' for correcting without yelling or punishing' },
  { lead: 'Emotional planner + gratitude list', rest: '' },
  { lead: 'US Letter + A4 formats', rest: ' — prints perfectly on any home printer' },
  { lead: 'Color + ink-saving black & white', rest: ' versions of everything' },
]

export type DeliveryItem = {
  lead: string
  rest: string
}

export const deliveryItems: DeliveryItem[] = [
  { lead: 'No zip files, no lost attachments', rest: ' — everything organized in one place.' },
  {
    lead: 'Open it anywhere',
    rest: ' — from your phone in the pickup line, or your laptop at 6am.',
  },
  { lead: 'Yours forever', rest: ' — free updates whenever we add something new.' },
]
